import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router-dom';
import Icon from '../../core/Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledErrorWrapper = styled.div`
  background: ${props => props.theme.colors.light};
  display: flex;
  max-width: ${rem('620px')};
  margin: 0 auto;
`;

const StyledIcon = styled(Icon)`
  height: ${rem('10px')};
  margin-right: ${rem('18px')};
  width: ${rem('5px')};
  fill: ${props => props.theme.colors.primary};
`;
const StyledErrorContent = styled.div`
  width: 100%;
  ${mediaqueries.greaterThan('tablet')`
    width: auto;
  `};
`;

const StyledTitle = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('22px')};
  text-align: center;
  color: ${props => props.theme.colors.grayDarkest};
  margin: 0;
  font-family: 'Montserrat Bold';
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${rem('30px')};
    text-align: left;
  `};
`;
const StyledErrorNumber = styled.p`
  font-family: 'Montserrat Bold';
  font-size: ${rem('80px')};
  line-height: normal;
  text-align: center;
  color: ${props => props.theme.colors.grayDarkest};
  margin: 0;
  position: relative;
  width: ${rem('170px')};
  margin: 0 auto;
  &:after {
    content: '*';
    font-weight: bold;
    color: ${props => props.theme.colors.primary};
    position: absolute;
    top: ${rem('-15px')};
    right: ${rem('-15px')};
  }
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${rem('100px')};
    width: ${rem('211px')};
  `};
`;
const StyledText = styled.p`
  font-family: ${props => props.theme.fonts.light};
  font-size: ${props => props.theme.fontSize.small};
  line-height: 1.22;
  letter-spacing: normal;
  margin: 0 auto ${rem('20px')} auto;
  text-align: center;
  color: ${props => props.theme.colors.grayDarkest};
  width: ${rem('170px')};
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${props => props.theme.fontSize.large};
    margin-bottom: ${rem('100px')};
    text-align: left;
    margin: 0 0 ${rem('100px')} 0;
    width: ${rem('211px')};
  `};
`;
const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSize.small};
  font-family: 'Montserrat Medium';
  &:hover {
    color: ${props => props.theme.colors.dark};
    ${StyledIcon} {
      fill: ${props => props.theme.colors.dark};
    }
  }
`;
const StyledErrorUlLinks = styled.ul`
  list-style-type: none;
  padding-left: 0;
  li {
    padding-left: 0;
    text-align: center;
    &:before {
      content: none;
    }
  }
  ${mediaqueries.greaterThan('tablet')`
    li {
      text-align: left;
    }
  `};
`;
const StyledErrorImage = styled.div`
  display: none;
  ${mediaqueries.greaterThan('tablet')`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-top: ${rem('30px')};
  `};
  svg {
    width: ${rem('316px')};
    height: ${rem('418px')};
  }
`;

export {
  StyledErrorWrapper,
  StyledErrorContent,
  StyledTitle,
  StyledErrorNumber,
  StyledText,
  StyledLink,
  StyledErrorUlLinks,
  StyledErrorImage,
  StyledIcon
};
